import { render, staticRenderFns } from "./NewDCheckboxPreview.vue?vue&type=template&id=116b2bc2&"
import script from "./NewDCheckboxPreview.vue?vue&type=script&lang=js&"
export * from "./NewDCheckboxPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDCheckboxPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports